<template>
  <!-- Single select range dropdown Start -->
  <div :class="['single-select-filter', { largeScreens: isLargeScreen }, 'mt-2']">
    <select
      id="range-dropdown"
      :class="['form-control', 'select-elem', { rangeSelectorDisabled: isdisable }]"
      v-model="selectedValue"
      @change="handleSelectionChange"
      :disabled="isdisable"
      style="font-size: 14px"
    >
      <option
        v-for="value in values"
        :key="value"
        :value="value"
      >
        {{ valueLabel(value) }} {{ unit }}
      </option>
    </select>
  </div>
  <!-- Single select range dropdown End -->
</template>

<script>
export default {
  props: {
    minvalue: Number,
    maxvalue: Number,
    range: {
      type: Number,
      default: 3250, 
    },
    isdisable: {
      type: Boolean,
      default: false,
    },
    unit: {
      type: String,
      default: 'Miles', 
    },
    applyBeforeFilter: {
      type: Function,
      default: null,
    },
    isLargeScreen: { 
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      selectedValue: this.range, // Setting the default value to user selected range
      values: this.generateValues()
    };
  },
  watch: {
    isdisable(newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.selectedValue = this.selectedValue || 3250; 
        });
      }
    },
    range(newVal) {
      this.selectedValue = newVal || 3250; // Update to new range or default to 3250
    }
  },
  methods: {
    handleSelectionChange() {
      this.sendResultValues();
      if (this.applyBeforeFilter) {
        this.applyBeforeFilter(this.selectedValue);
      }
    },
    sendResultValues() {
      this.$emit('send-result-values', this.selectedValue);
    },
    generateValues() {
      return [10, 25, 50, 100, 250, 3250]; // Add 3250 as the value for 250+
    },
    valueLabel(value) {
      return value === 3250 ? '250+' : value; // Display 250+ for the value 3250
    }
  }
};
</script>

<style scoped>
.single-select-filter {
  width: 100%;
  position: relative;
}

.select-elem {
  width: 100%;
  padding: 8px 12px;
  font-size: 1rem;
  border-radius: 5px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #707070;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  transition: background-color 0.2s, border-color 0.2s;
  cursor: pointer;
}

.select-elem:focus {
  border-color: #0056b3;
}

.select-elem:hover {
  background-color: #f0f0f0;
}

.select-elem:disabled {
  opacity: 0.5;
  pointer-events: none;
}
</style>
